<template>
  <RevInputText
    :id="fieldName"
    v-model="model"
    autocomplete="off"
    autocorrect="off"
    class="md:min-w-[20rem] md:flex-1"
    data-cs-mask
    :description
    :error
    :label
    :name="fieldName"
    spellcheck="false"
  />
</template>

<script setup lang="ts">
import { RevInputText } from '@ds/components/InputText'
import type { InputValue } from '@ds/types/InputValue'

defineProps<{
  fieldName: string
  label: string
  error?: string
  description?: string
}>()

const model = defineModel<InputValue>()
</script>
